export const getInitials = (name) => {
  return name
    .split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase();
};

export const getPracticeMapUrl = (item) => {
  if (item?.address_url && item?.address_url != "null") {
    return item.address_url;
  }

  const fullAddress = `${item?.address}, ${item?.suburb?.name}, ${item?.state?.name}`;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    fullAddress
  )}`;
};
